var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.31 291.31",
    style: {
      enableBackground: "new 0 0 291.31 291.31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D99666"
    },
    d: "M9.099,0h273.112L254.9,263.999L154.759,291.31h-18.207L36.41,263.999L9.099,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B459"
    },
    d: "M145.655,27.302h100.141l-18.207,209.386l-81.933,27.311 C145.655,263.999,145.655,27.302,145.655,27.302z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "218.649,81.806 221.516,54.613 63.43,54.613 66.616,81.806 69.53,118.403 69.493,118.403  72.252,145.641 178.228,145.641 174.587,188.975 145.655,198.115 145.655,197.833 107.183,187.664 104.825,163.785 72.698,163.785  77.013,207.647 77.013,209.44 145.655,227.584 203.218,209.44 203.919,209.44 203.937,209.194 204.064,209.176 204.064,207.738  209.272,145.641 209.39,145.641 212.158,118.403 102.94,118.403 100.027,81.806  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5E5E5"
    },
    points: "145.655,54.613 63.43,54.613 66.616,81.806 69.53,118.403 69.493,118.403 72.252,145.641  145.655,145.641 145.655,118.403 102.94,118.403 100.027,81.806 145.655,81.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5E5E5"
    },
    points: "145.655,197.833 107.183,187.664 104.825,163.785 72.698,163.785 77.013,207.647  77.013,209.44 145.655,227.584 145.655,198.115  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5Icon);
export default __webpack_public_path__ + "static/media/HTML5Icon.558b233d20e3804cc1d46cc967058ec9.svg";
export { ForwardRef as ReactComponent };